import { NgModule } from '@angular/core';
import { CanMatchFn, PreloadAllModules, Route, RouterModule, Routes, UrlSegment } from '@angular/router';

import { CardComponent } from '@libs/layouts/card';
import { SideNavComponent } from '@libs/layouts/side-nav';

import { LoggedInGuard, LoggedOutGuard } from '@app/common/guards';


// The empty-path layout blocks below would match the bare root URL even though
// none of their children do, stealing '/' from the public showcase. Only let
// them match when there is an actual URL segment to consume.
export const hasUrlSegments: CanMatchFn = (route: Route, segments: UrlSegment[]) => !!segments.length;

export const routes: Routes = [
  {
    path: '',
    canMatch: [hasUrlSegments],
    canActivate: [LoggedInGuard],
    data: {
      fsNav: { root: true },
    },
    children: [
      {
        path: '',
        component: SideNavComponent,
        children: [
          { path: 'account', loadChildren: () => import('./account/account.module').then((m) => m.AccountModule) },
          { path: 'sites', loadChildren: () => import('./site/site.module').then((m) => m.SiteModule) },
          {
            path: 'admin',
            loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            path: 'system',
            loadChildren: () => import('./system/system.module').then((m) => m.SystemModule),
            data: {
              fsNav: { root: true },
            },
          },
          {
            path: 'notfound',
            loadChildren: () => import('@libs/not-found/not-found.module').then((m) => m.NotFoundModule),
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: CardComponent,
    canMatch: [hasUrlSegments],
    canActivate: [LoggedOutGuard],
    children: [
      {
        path: 'password',
        children: [
          {
            path: 'change',
            loadChildren: () => import('@firestitch/password-reset').then((m) => m.FsForcePasswordChangeModule),
          },
        ],
        data: { bodyClass: 'body-card' },
      },
      {
        path: 'invite',
        loadChildren: () => import('@firestitch/invite').then((m) => m.FsInviteModule),
        canActivate: [LoggedOutGuard],
        data: { bodyClass: 'body-card' },
      },
      {
        path: 'signin',
        loadChildren: () => import('./signin').then((m) => m.SigninModule),
        data: { bodyClass: 'body-card body-signin' },
      },
    ],
  },
  {
    path: 'blank',
    component: CardComponent,
  },
  // Public components showcase. Must stay last before the wildcard: its ':name'
  // demo route matches any single segment the routes above did not claim.
  {
    path: '',
    loadChildren: () => import('./showcase').then((m) => m.ShowcaseModule),
  },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        useHash: (+document.location.port === 8080 || document.location.protocol === 'file:'),
        preloadingStrategy: PreloadAllModules,
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
